import React, { useState, useEffect } from 'react';
import { collection, query, orderBy, getDocs } from 'firebase/firestore';
import { db } from '../../../firebase';
import { Link } from 'react-router-dom';
import '../event/archive_event.css';

const ArchiveEventList = () => {
  const [events, setEvents] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchArchive = async () => {
      try {
        // Query your target archive collection sorted by date descending (Newest first)
        const q = query(collection(db, "parmEvent"), orderBy("event_date", "desc"));
        const snap = await getDocs(q);
        
        const archiveList = snap.docs.map(doc => ({
          id: doc.id,
          ...doc.data()
        }));
        
        setEvents(archiveList);
      } catch (err) {
        console.error("Error fetching event archives:", err);
      } finally {
        setLoading(false);
      }
    };

    fetchArchive();
  }, []);

  if (loading) return <div className="loader">Loading PArM Archives...</div>;

  return (
    <section className="archive-event-section">
      <div className="archive-event-container">
        <h2>PArM Past Events Archive</h2>
        <p>Explore our historical roadmap of professional initiatives and milestones.</p>
        
        {events.length === 0 ? (
          <p className="archive-no-events">No archived events found.</p>
        ) : (
          <div className="archive-event-grid">
            {events.map((event) => (
              // 🟢 Link targets /archive/event_001 dynamically
              <Link to={`/archive-event-detail-parm/${event.event_id}`} key={event.id} className="archive-card">
                <div className="archive-event-card-content">
                  {/* Optional: Add a thumbnail element if you store an event cover image */}
                  {event.event_cover && <img src={event.event_cover} alt={event.event_title} className="archive-card-thumbnail" />}
                  
                  <h3>{event.event_title}</h3>
                  <p className="archive-event-date">
                    📅 {event.event_date?.seconds 
                      ? new Date(event.event_date.seconds * 1000).toLocaleDateString('en-MY', { year: 'numeric', month: 'long', day: 'numeric' })
                      : event.event_date}
                  </p>
                  <span className="archive-view-more-btn">View Details ➔</span>
                </div>
              </Link>
            ))}
          </div>
        )}
      </div>
    </section>
  );
};

export default ArchiveEventList;